import {Vue as VueIntegration} from "@sentry/integrations";

class SentryIntegration {
  bind(Vue) {
    if (!window.Sentry) {
      return false;
    }

    if (!Sentry.getCurrentHub().getClient()) {
      return console.error(
        'Unable to integrate Vue into Sentry as generic JS client ("Sentry.init") was not yet initialized'
      );
    }

    if (!this.customIntegrations) {
      this.customIntegrations = [];
    }

    const currentHub = Sentry.getCurrentHub();
    const currentClient = currentHub.getClient();

    const client = new Sentry.BrowserClient({
      ...currentClient.getOptions(),
      integrations: integrations => {
        this.customIntegrations.push(new VueIntegration({Vue}));
        return [...integrations, ...this.customIntegrations];
      }
    });

    currentHub.bindClient(client);
  }
}

export default new SentryIntegration();
